import i18n from 'i18next';

import { addToast } from 'core/notifications';

export default ({ errors, formState, forceUpdate }) => {
  let alreadyNotified = false;

  errors?.forEach(({ message, source }) => {
    const sourceName = source.split('.').pop();
    const field = formState[sourceName];

    if (field) {
      Object.assign(field, { error: message, hasError: true });
    } else if (sourceName.split('.').pop() === 'base') {
      addToast(message, 'error');
      alreadyNotified = true;
    }
  });

  forceUpdate();

  if (!alreadyNotified) addToast(i18n.t('form-errors'), 'warning');
}
